import {Module} from "vuex";
import {Vue} from "vue-property-decorator";

export interface VersionInterface {
  version: string;
  date: string;
}

export const globalInformationsModule: Module<any, any> = {
  state: {
    versionInformations: {
      version: '' as string,
      date: '' as string,
    }
  },
  getters: {
    getVersionInformations(state) {
      return state.versionInformations;
    }
  },
  mutations: {
    updateVersionInformations(state, data: VersionInterface) {
      Vue.set(state, 'versionInformations', data);
    },
  },
  actions: {},
};
